import template from './adpFileUpload.html';
import controller from './adpFileUpload.controller';
import './adpFileUpload.less';

let adpFileUploadComponent = {
  restrict: 'E',
  bindings: {
      isFileUploaded:'='
  },
  transclude: true,
  template,
  controller
};

export default adpFileUploadComponent;



// WEBPACK FOOTER //
// ./src/app/components/adpFileUpload/adpFileUpload.component.js